"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const TextArea_style_1 = require("./TextArea.style");
function TextArea({ isEditable = true, onChange, style = [], value, hasError = false, onKeyPress, }) {
    return (react_1.default.createElement(react_native_1.TextInput, { value: value, onChangeText: onChange, editable: isEditable, multiline: true, numberOfLines: 6, onKeyPress: onKeyPress, style: [...[TextArea_style_1.styles.input, hasError ? TextArea_style_1.styles.error : null], ...style] }));
}
exports.TextArea = TextArea;
